<template>
<div class="new-navigation">
    <div class="navigation-item company-favicon">
        <img src="/static/favicon.png"/>
        <div class="navigation-name">{{navigationTitle}}</div>
    </div>
    <div class="navigation-apps-section">
        <div class="navigation-apps navigation-item-width" v-if="!showSettings">
            <div class="navigation-item" :class="{'active-app': activeApp == 'apps'}" @click="backToApps()">
                <v-icon dark class="navigation-icons">icon-home</v-icon>
                <!-- <div><i class="navigation-icons">icon-home</i></div> -->
                <div class="navigation-name">All {{tenantInfo.app_label || 'Apps'}}</div>
            </div>
            <div class="navigation-item" 
                :class="{'active-app': (activeApp == 'all-companies-dashboard') || (activeApp == 'mssp-dashboard')}"
                v-if="showEpalldashboard || showMsspDashboard"
                @click="switchApp({name:showEpalldashboard ? 'all-companies-dashboard' : 'mssp-dashboard'})">
                <v-icon dark class="navigation-icons">icon-dashboard</v-icon>
                <!-- <div><i class="navigation-icons">icon-home</i></div> -->
                <div class="navigation-name">Dashboard</div>
            </div>
            <div class="navigation-divider" v-if="availableApps.length > 0">
                <div class="navigation-item" :class="{'active-app': activeApp === value.name}" v-for="value in availableApps" :key="value.name" @click="switchApp(value)">
                    <v-icon dark class="navigation-icons">{{value.icon}}</v-icon>
                    <div class="navigation-name">{{value.displayName}}</div>
                </div>
            </div>
        </div>
        <div class="navigation-settings navigation-item-width" v-if="!showSettings">
            <div class="navigation-item" @click="showSettings = !showSettings">
                <v-icon class="navigation-icons">icon-person</v-icon>
                <!-- <div><i class="navigation-icons material-icons">person</i></div> -->
                <div class="navigation-name">Settings</div>
                <v-icon class="settings-arrow navigation-icons">icon-arrow_right</v-icon>
                <!-- <div class="settings-arrow"><i class="material-icons">arrow_forward</i></div> -->
            </div>
        </div>
        <div class="navigation-apps navigation-item-width" v-if="showSettings">
            <div class="navigation-item" :class="{'active-app': showSettings}" @click="showSettings = !showSettings">
                <v-icon class="navigation-icons">icon-person</v-icon>
               <!-- <div><i class="navigation-icons material-icons">person</i></div> -->
                <div class="navigation-name">Settings</div>
                <div class="settings-arrow backarrow"><i class="material-icons">arrow_backward</i></div>
            </div>
            <div class="navigation-user-item">
                <div class="navigation-user-info">
                    <div class="navigation-user-name" :title="userInfo['username']+'@'+userInfo['domain']">{{userInfo['username']+'@'+userInfo['domain']}}</div>
                    <div class="navigation-user-role">{{userInfo['is_superadmin'] ? 'Super Admin' : 'User'}}</div>
                </div>
            </div>
            <div class="navigation-item" v-if="userInfo['has_2fa']" @click="showModal = true">
                <div><v-icon class="navigation-icons">icon-phonelink_lock</v-icon></div>
                <div class="navigation-name">Reset 2FA</div>
            </div>
            <!-- <div class="navigation-item" v-if="userInfo['has_2fa']" @click="showBackupCodesModal = true">
                <div><v-icon class="navigation-icons">icon-list</v-icon></div>
                <div class="navigation-name">2FA Backup Codes</div>
            </div> -->
            <div class="navigation-item" @click="showPasswordModal = true" :class="userInfo['sso_user'] ? 'disabled' : ''">
                <div><v-icon class="navigation-icons">icon-lock</v-icon></div>
                <div class="navigation-name">Change Password</div>
            </div>
            <div class="navigation-divider" @click="backToDocsPage()" v-if="userInfo['enable_docspage'] && pagename != 'docs'">
                <div class="navigation-item">
                    <div><v-icon dark class="navigation-icons">icon-help</v-icon></div>
                    <div class="navigation-name">Constella Docs Home</div>
                </div>
            </div>
            <div class="navigation-divider">
                <div class="navigation-item">
                    <div><v-icon dark class="navigation-icons">icon-settings</v-icon></div>
                    <div class="navigation-name"><span><a href="mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support" target="new">Contact Constella Support</a></span></div>
                </div>
            </div>
            <!-- <div class="navigation-item" v-for="loginsetting in loginSettings" :key="loginsetting.name" @click="switchApp(loginsetting)">
                <div><i class="navigation-icons material-icons">{{loginsetting.icon}}</i></div>
                <div class="navigation-name">{{loginsetting.displayName}}</div>
            </div> -->
            <div class="navigation-divider"></div>
            <div class="navigation-item" @click="logout">
                <div><v-icon class="navigation-icons">icon-logout</v-icon></div>
                <div class="navigation-name">Logout</div>
            </div>
            
        </div>
    </div>
    <modalpopupVue v-if="showModal" @close="closePopup" :dialogStatus="showModal"></modalpopupVue>
    <backupCodesModal v-if="showBackupCodesModal" @close="showBackupCodesModal = false" :fromHeader="true" :dialogStatus="showBackupCodesModal"></backupCodesModal>
    <changePasswordPopupVue v-if="showPasswordModal" @close="showPasswordModal = false" :dialogStatus="showPasswordModal"></changePasswordPopupVue>
</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';
import modalpopupVue from './modalpopup2fa.vue';
import backupCodesModal from './backupCodesModal.vue';
import changePasswordPopupVue from './changePasswordPopup.vue';
import confirmationDialog from '../../epsrc/components/common/confirmationDialog';

import Vue from 'vue';

export default {
    props: {
        app: {
            type: String,
            default: 'ug'
        },
        availableApps: {
            type: Array,
            default: function() {
                return []
            }
        },
        activeApp: {
            type: String,
            default: 'dashboard'
        },
        pagename: {
            type: String,
            default: null
        },
        navigationTitle: {
            type: String,
            default: "Constella"
        },
        showEpalldashboard: {
            type: Boolean,
            default: false
        },
        showMsspDashboard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showSettings: false,
            hide:null,
            isSuperAdmin: null,
            showModal: false,
            showBackupCodesModal: false,
            showPasswordModal: false,
            server: null
        }
    },
    created() {
        let self = this;

        if(window.location.search && window.location.search.split('at=')[1]){
            self.accessToken = window.location.search.split('at=')[1];
        }
        if(!self.userInfo){
            self.initializeData({accessToken: self.accessToken});
        }
        self.getCurrentHostName();
    },
    watch: {
        serverInfo() {
            var self = this;
            self.server = this.serverInfo;
            console.log("The Server is .......", this.server);
        }
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
            getCurrentHostName: 'loginDetails/getCurrentHostName'
        }),
        // get_host_name() {
        //     var self = this;
        //     self.server = null;
        //     Vue.http.get('/get_host_name/').then(
        //         (res) => {
        //             let data = res.data.data || '';
        //             console.log(res.data.data, window.location.host);
        //             if (data == window.location.host) {
        //                 self.server = 'uig'
        //             } else {
        //                 self.server = 'dome'
        //             }
        //         }, (error) => {
        //             console.log(error, "Unable to fetch host name");
        //             self.server = null;
        //         }
        //     );
        // },
        switchApp(app){
            this.$emit('switchApp', app);
        },
        logout(){
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/logout/')
			.then((res) => {
                try{
                    sessionStorage.clear();
                    localStorage.clear();
                    if(this.userInfo['sso_redirected_user']) {
                        location.href = "/login?loggedOut=true";
                    } else if(this.server && this.server == 'dome') { 
                        window.location.href = '/gui/auth/logout.action';
                    } else {
                        window.location.href = '/login';
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
			}, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
				//console.log("api failed with error: ", error);
			})
        },
        closePopup(flag){
            this.showModal = false; 
            if(flag){
                this.showBackupCodesModal = true;
            }
        },
        backToApps(){
            if(this.server && this.server == 'dome') {
                window.location = '/static/uiGateway.html#/apps';
            } else {
                window.location = '/#apps';
            }
        },
        backToDashboard() {
            window.location = '/#dashboard';
        },
        backToDocsPage(){
            window.open('/#docs/all', "_blank");
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.loginDetails.loggedInUserInformation,
            tenantInfo: state => state.loginDetails.loggedInUserInformation ? state.loginDetails.loggedInUserInformation['switched_tenant'] : {},
            serverInfo: state => state.loginDetails.server
        }),
        loginSettings() {
            let defaultLoginSettings = [ 
                {
                    name: 'reset_2fa',
                    displayName: 'Reset 2FA',
                    icon: "phonelink_lock"
                },
                {
                    name: '2fa_backup_codes',
                    displayName: '2FA Backup Codes',
                    icon: 'format_list_bulleted'
                },
                {
                    name: 'change_password',
                    displayName: 'Change Password',
                    icon: 'lock_outline'
                },
            ]
            return defaultLoginSettings;
        }
    },
    components: {
        modalpopupVue,
        backupCodesModal,
        changePasswordPopupVue,
        confirmationDialog
    }
}
</script>

<style lang="scss" scoped>
.new-navigation {
    // width: 2%;
    width:48px;
    height:100%;
    // background-color: rgb(40,41,43);
    background-color: rgb(40,41,43);
    // position: absolute;
    position: fixed;
    top:0px;
    left: 0px;
    z-index: 100000000;
    color: white;
    // padding: .3rem;
    transition: width .2s;
    display: flex;
    flex-direction: column;

    .navigation-divider {
        border-top: 1px solid #5c5a57;
        margin-top: .5rem;
        margin-bottom: .5rem;
        padding-top: .5rem;
    }

    .navigation-item-width {
        width: 100%;
    }

    .active-app {
        background-color: #0000001A;
        border-left: 4px solid #e34e25 !important;     
    }

    .active-app:hover {
        background-color: #0000001A !important;
        .navigation-icons {
            color: #76716c !important;
        }
    }

    .navigation-apps-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        margin-top: 3rem;

        // align-items: center

    }
    .navigation-icons {
        font-size: 1.7rem;
        color: #76716c;
    }

    .navigation-name {
        color: #cacacb;
        text-transform: capitalize;
    }

    @mixin navigation-item-padding {
        padding-left: .7rem;
        padding-top: .6rem;
        padding-bottom: .6rem;
        box-sizing: border-box;
        border-left: 4px solid transparent;

    }

    .navigation-user-item {
        @include navigation-item-padding;
        border-left: 8px solid transparent;
        background-color: #736B63;

        .navigation-user-info {
            visibility: hidden;
            white-space: nowrap;
        }
    }


    .navigation-item {
        width: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        @include navigation-item-padding;
        .settings-arrow {
            align-self: flex-end;
            visibility: hidden;
            margin-left: 100px;
            color: #cacacb;
            font-size: 1.2rem;

        }

        a {
            text-decoration: none;
            color: inherit;
        }

       
    }

    .navigation-item:hover {
        background-color: #3e3f41;

        .settings-arrow {
            visibility: visible;
        }

        .navigation-icons {
            color: #e34e25;
        }
    }

    .company-favicon {
        padding:0px;
        height: 64px;
        background-color: black;
        padding-left: .3rem;
        box-sizing: border-box;
        // align-items: center;

    }

    .navigation-name {
        display: none;
        white-space: nowrap;
        background-color: #FFFFFF00;

    }
  
}

.new-navigation:hover {
    width: 240px;
    .navigation-name {
        display: inline;
        margin-left: .5rem;
    }

    

    .settings-arrow.backarrow, .navigation-user-info {
        visibility: visible;
    }
    .navigation-user-name{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .navigation-apps-section {
        align-items: flex-start !important;
    }
}

// .navigation-icons:hover {
//     display: block;
// }
</style>